import request from '@/utils/request'
import requestJson from '@/utils/requestJson'
import service from '@/utils/request'

// 门店列表接口
export function getshoplist(data) {
  return request({
    url: '/admin/shop/getlist',
    method: 'get',
    params: data
  })
}

// 获取当前账户下用户可用门店
export function userPermissionShopGetList(data) {
  return request({
    url: '/admin/user_permission/getPermissionShops',
    method: 'get',
    params: data
  })
}

// 新增门店接口
export function shopadd(data) {
  return request({
    url: '/admin/shop/add',
    method: 'post',
    data
  })
}

// 删除门店接口
export function shopdel(data) {
  return request({
    url: '/admin/shop/del',
    method: 'get',
    params: data
  })
}
// 修改门店接口
export function shopup(data) {
  return request({
    url: '/admin/shop/up',
    method: 'post',
    data
  })
}
// 查询门店详情接口
export function shopgetone(data) {
  return request({
    url: '/admin/shop/getone',
    method: 'get',
    params: data
  })
}
// 门店激活
export function shopactive(data) {
  return request({
    url: '/admin/shop/active',
    method: 'get',
    params: data
  })
}

// 门店锁定
export function shopLock(data) {
  return request({
    url: '/admin/shop/lock',
    method: 'get',
    params: data
  })
}

// 加盟列表
export function companyGetlist(data) {
  return request({
    url: '/admin/company/getlist',
    method: 'get',
    params: data
  })
}
// 删除加盟
export function companydel(data) {
  return request({
    url: '/admin/company/del',
    method: 'get',
    params: data
  })
}

// 激活加盟
export function companyactive(data) {
  return request({
    url: '/admin/company/active',
    method: 'get',
    params: data
  })
}


// 用户列表

export function userGetlist(data) {
  return request({
    url: '/admin/user/getlist',
    method: 'get',
    params: data
  })
}
// 用户锁定
export function userLock(data) {
  return request({
    url: '/admin/user/lock',
    method: 'get',
    params: data
  })
}

// 用户激活
export function userActive(data) {
  return request({
    url: '/admin/user/active',
    method: 'get',
    params: data
  })
}

// 删除用户
export function userDel(data) {
  return request({
    url: '/admin/user/del',
    method: 'get',
    params: data
  })
}

// 新增用户
export function userAdd(data) {
  return request({
    url: '/admin/user/add',
    method: 'post',
    data
  })
}
// 用户详情
export function userGteone(data) {
  return request({
    url: '/admin/user/getone',
    method: 'get',
    params: data
  })
}

// 编辑用户
export function userUp(data) {
  return request({
    url: '/admin/user/up',
    method: 'post',
    data
  })
}


// 新增商户
export function companyAdd(data) {
  return request({
    url: '/admin/company/add',
    method: 'post',
    data
  })
}

// 锁定商户
export function companyLock(data) {
  return request({
    url: '/admin/company/lock',
    method: 'get',
    params: data
  })
}

// 商户明细
export function companyGetOne(data) {
  return request({
    url: '/admin/company/getOne',
    method: 'get',
    params: data
  })
}

// 商户修改
export function companyUp(data) {
  return request({
    url: '/admin/company/up',
    method: 'post',
    data
  })
}
// 客户列表
export function customerGetList(data) {
  return request({
    url: '/admin/customer/getList',
    method: 'get',
    params: data
  })
}

// 客户锁定
export function customerLock(data) {
  return request({
    url: '/admin/customer/lock',
    method: 'get',
    params: data
  })
}
// 客户删除
export function customerDel(data) {
  return request({
    url: '/admin/customer/del',
    method: 'get',
    params: data
  })
}
// 客户激活
export function customerActive(data) {
  return request({
    url: '/admin/customer/active',
    method: 'get',
    params: data
  })
}
// 客户编辑
export function customerGetOne(data) {
  return request({
    url: '/admin/customer/getOne',
    method: 'get',
    params: data
  })
}


// 商品分类列表
export function itemClassGetList(data) {
  return request({
    url: '/admin/item_class/getList',
    method: 'get',
    params: data
  })
}

// 新增分类
export function itemClassAdd(data) {
  return request({
    url: '/admin/item_class/add',
    method: 'post',
    data
  })
}


// 删除产品分类
export function itemClassDel(data) {
  return request({
    url: '/admin/item_class/del',
    method: 'get',
    params: data
  })
}


// 激活分类
export function itemClassActive(data) {
  return request({
    url: '/admin/item_class/active',
    method: 'get',
    params: data
  })
}


// 锁定分类
export function itemClassLock(data) {
  return request({
    url: '/admin/item_class/lock',
    method: 'get',
    params: data
  })
}

// 分类明细
export function itemClassGetOne(data) {
  return request({
    url: '/admin/item_class/getOne',
    method: 'get',
    params: data
  })
}

// 修改分类
export function itemClassUp(data) {
  return request({
    url: '/admin/item_class/up',
    method: 'post',
    data
  })
}


// 商品管理接口
// 列表
export function itemListGetList(data) {
  return request({
    url: '/admin/item_list/getList',
    method: 'get',
    params: data
  })
}

// 删除商品
export function itemListDel(data) {
  return request({
    url: '/admin/item_list/del',
    method: 'get',
    params: data
  })
}

// 下架
export function itemListLock(data) {
  return request({
    url: '/admin/item_list/lock',
    method: 'get',
    params: data
  })
}

// 上架
export function itemListActive(data) {
  return request({
    url: '/admin/item_list/active',
    method: 'get',
    params: data
  })
}

// 新增商品
export function itemListAdd(data) {
  return request({
    url: '/admin/item_list/add',
    method: 'post',
    data
  })
}
// 修改商品
export function itemListUp(data) {
  return request({
    url: '/admin/item_list/up',
    method: 'post',
    data
  })
}
// 商品详情
export function itemListGetOne(data) {
  return request({
    url: '/admin/item_list/getOne',
    method: 'get',
    params: data
  })
}

// 平台商品导入
export function itemListImportExcel(data) {
  return service({
    url: '/admin/item_list/importExcel',
    method: 'post',
    data: data
  })
}

// 平台商品下载模板
export function itemListGetTemplate(data) {
  return request({
    url: '/admin/item_list/getTemplate',
    method: 'get',
    params: data
  })
}


// 区域列表
export function areaGetlist(data) {
  return request({
    url: '/admin/area/getlist',
    method: 'get',
    params: data
  })
}

export function areaDel(data) {
  return request({
    url: '/admin/area/del',
    method: 'get',
    params: data
  })
}

export function areaUp(data) {
  return request({
    url: '/admin/area/up',
    method: 'post',
    data
  })
}

export function areaAdd(data) {
  return request({
    url: '/admin/area/add',
    method: 'post',
    data
  })
}


// 获取权限树
export function permissionGetlist(data) {
  return request({
    url: '/admin/permission/getlist',
    method: 'get',
    params: data
  })
}

// 获取用户下的门店
export function getUserShoplist(data) {
  return request({
    url: '/admin/shop_user/getUserShoplist',
    method: 'get',
    params: data
  })
}

// 获取用户的权限列表
// 注意有两种用法：登录时，获得自己的权限列表；配置别人时，获得他人的权限列表
export function userPermissionGetlist(data) {
  return request({
    url: '/admin/user_permission/get',
    method: 'get',
    params: data
  })
}
// 设置用户的权限列表
export function userPermissionSetlist(data) {
  return request({
    url: '/admin/user_permission/set',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 获得用户的菜单列表
export function userMenuGetList(data) {
  return request({
    url: '/admin/user_permission/getMenu',
    method: 'get',
    params: data
  })
}

// 新增用户
export function customerAdd(data) {
  return request({
    url: '/admin/customer/add',
    method: 'post',
    data
  })
}

// 修改接口
export function customerUp(data) {
  return request({
    url: '/admin/customer/up',
    method: 'post',
    data
  })
}

// 客户外卖店铺列表
export function customerTakeoutGetList(data) {
  return request({
    url: '/admin/customer_takeout/getList',
    method: 'get',
    params: data
  })
}

// 新增客户外卖店铺
export function customerTakeoutAdd(data) {
  return request({
    url: '/admin/customer_takeout/add',
    method: 'post',
    data
  })
}

// 修改客户外卖店铺
export function customerTakeoutUp(data) {
  return request({
    url: '/admin/customer_takeout/up',
    method: 'post',
    data
  })
}

// 删除客户外卖店铺
export function customerTakeoutDel(data) {
  return request({
    url: '/admin/customer_takeout/del',
    method: 'get',
    params: data
  })
}


// 供应商列表
export function supplierGetList(data) {
  return request({
    url: '/admin/supplier/getlist',
    method: 'get',
    params: data
  })
}

// 查询允许用户查看的供应商
export function userPermissionSupplierGetList(data) {
  return request({
    url: '/admin/supplier/getPermissionSupplierList',
    method: 'get',
    params: data
  })
}

// 供应商删除
export function supplierDel(data) {
  return request({
    url: '/admin/supplier/del',
    method: 'get',
    params: data
  })
}
// 供应商激活
export function supplierActive(data) {
  return request({
    url: '/admin/supplier/active',
    method: 'get',
    params: data
  })
}
// 供应商锁定
export function supplierLock(data) {
  return request({
    url: '/admin/supplier/lock',
    method: 'get',
    params: data
  })
}
// 供应商添加
export function supplierAdd(data) {
  return request({
    url: '/admin/supplier/add',
    method: 'post',
    data
  })
}
// 供应商修改
export function supplierUp(data) {
  return request({
    url: '/admin/supplier/up',
    method: 'post',
    data
  })
}
// 供应商明细
export function supplierGetOne(data) {
  return request({
    url: '/admin/supplier/getOne',
    method: 'get',
    params: data
  })
}

export function stockSupplierGetList(data) {
  return request({
    url: '/admin/stock_supplier/getlist',
    method: 'get',
    params: data
  })
}

// 新增供货清单
export function stockSupplierAdd(data) {
  return requestJson({
    url: '/admin/stock_supplier/add',
    method: 'post',
    data
  })
}

// 编辑供货清单
export function stockSupplierUp(data) {
  return requestJson({
    url: '/admin/stock_supplier/up',
    method: 'post',
    data
  })
}


// 删除供货清单
export function stockSupplierDel(data) {
  return requestJson({
    url: '/admin/stock_supplier/del',
    method: 'post',
    data
  })
}

// 资金账户
export function companyAccountGetList(data) {
  return request({
    url: '/admin/company_account/getlist',
    method: 'get',
    params: data
  })
}

// 激活资金账户
export function companyAccountActive(data) {
  return request({
    url: '/admin/company_account/active',
    method: 'get',
    params: data
  })
}

// 锁定资金账户
export function companyAccountLock(data) {
  return request({
    url: '/admin/company_account/lock',
    method: 'get',
    params: data
  })
}

// 删除资金账户
export function companyAccountDel(data) {
  return request({
    url: '/admin/company_account/del',
    method: 'get',
    params: data
  })
}

// 删除资金账户
export function companyAccountSetSystem(data) {
  return request({
    url: '/admin/company_account/setSystem',
    method: 'get',
    params: data
  })
}

// 新增资金账号
export function companyAccountAdd(data) {
  return request({
    url: '/admin/company_account/add',
    method: 'post',
    data
  })
}

// 详情资金账号
export function companyAccountGetOne(data) {
  return request({
    url: '/admin/company_account/getOne',
    method: 'get',
    params: data
  })
}

// 修改资金账号
export function companyAccountUp(data) {
  return request({
    url: '/admin/company_account/up',
    method: 'post',
    data
  })
}

// 获取用户资金权限
export function userFinancePermissionGet(data) {
  return request({
    url: '/admin/User_finance_permission/get',
    method: 'get',
    params: data
  })
}

export function userFinancePermissionSet(data) {
  return requestJson({
    url: '/admin/User_finance_permission/set',
    method: 'post',
    data
  })
}


export function commonQrGun(data) {
  return request({
    url: '/admin/common/qrGun',
    method: 'get',
    params: data
  })
}

// 更新采购价
export function stockSupplierUpPrice(data) {
  return requestJson({
    url: '/admin/stock_supplier/upPrice',
    method: 'post',
    data
  })
}

// 获取最新采购价
export function stockSupplierGetPrice(data) {
  return request({
    url: '/admin/stock_supplier/getPrice',
    method: 'get',
    params: data
  })
}

//取应收列表
export function shouldGetGetList(data) {
  return request({
    url: '/admin/should_get/getList',
    method: 'get',
    params: data
  })
}

//取一条应收记录
export function shouldGetGetOne(data) {
  return request({
    url: '/admin/should_get/getOne',
    method: 'get',
    params: data
  })
}

//取应付列表
export function shouldPayGetList(data) {
  return request({
    url: '/admin/should_pay/getList',
    method: 'get',
    params: data
  })
}

//取一条应付记录
export function shouldPayGetOne(data) {
  return request({
    url: '/admin/should_pay/getOne',
    method: 'get',
    params: data
  })
}


//首页统计
export function getAllInfo(data) {
  return request({
    url: '/admin/common/getAll_info',
    method: 'get',
    params: data
  })
}

//首页员工绩效
export function userSellInfo(data) {
  return request({
    url: '/admin/common/userSellInfo',
    method: 'get',
    params: data
  })
}

//员工绩效
export function userSellInfoEx(data) {
  return request({
    url: '/admin/common/userSellInfoEx',
    method: 'get',
    params: data
  })
}

//员工本月销售采购绩效列表
export function userSellInfobymonth(data) {
  return request({
    url: '/admin/Report_list/getperformancebyuserid',
    method: 'get',
    params: data
  })
}

//全部员工销售绩效列表
export function alluserSellInfo(data) {
  return request({
    url: '/admin/Report_list/getperformance',
    method: 'get',
    params: data
  })
}

//全部员工采购绩效列表
export function alluserBuyInfo(data) {
  return request({
    url: '/admin/Report_list/getperformanceII',
    method: 'get',
    params: data
  })
}

//商品分析
export function productList(data) {
  return request({
    url: '/admin/Report_list/productlist',
    method: 'get',
    params: data
  })
}

// 日志列表
export function logGetlist(data) {
  return request({
    url: '/admin/zzs_common_log/getlist',
    method: 'get',
    params: data
  })
}

// 部门列表
export function partGetlist(data) {
  return request({
    url: '/admin/part/getlist',
    method: 'get',
    params: data
  })
}


// 外卖单汇总
export function orderTakeouGetOrderAllInfo(data) {
  return request({
    url: '/admin/order_takeout/getOrderAllInfo',
    method: 'get',
    params: data
  })
}

// 外卖单汇总
export function orderTakeouGetOrderAllInfoII(data) {
  return request({
    url: '/admin/Report_list/gettakeoutinfo',
    method: 'post',
    data
  })
}

//微信群列表
export function wxRoomInfoList(data) {
  return request({
    url: '/admin/wx_room_info/getList',
    method: 'get',
    params: data
  })
}

// 删除微信群
export function wxRoomDel(data) {
  return request({
    url: '/admin/wx_room_info/del',
    method: 'get',
    params: data
  })
}
// 微信群详情
export function wxRoomGteone(data) {
  return request({
    url: '/admin/wx_room_info/getone',
    method: 'get',
    params: data
  })
}
// 新增微信群
export function wxRoomAdd(data) {
  return request({
    url: '/admin/wx_room_info/add',
    method: 'post',
    data
  })
}
// 编辑微信群
export function wxRoomUp(data) {
  return request({
    url: '/admin/wx_room_info/up',
    method: 'post',
    data
  })
}

// 获取门店临期统计
export function getLinqi(data) {
  return request({
    url: '/admin/Report_list/linqicount',
    method: 'post',
    data
  })
}
// 门店/部门指标列表（新版）
export function gettradelist(data) {
  return request({
    url: '/admin/Shop_trade/getlist',
    method: 'get',
    params: data
  })
}

// 保存/更新指标（新版统一接口）
export function tradeSave(data) {
  return request({
    url: '/admin/Shop_trade/save',
    method: 'post',
    data
  })
}

// 获取指标定义列表
export function getIndicatorDefinitions(data) {
  return request({
    url: '/admin/Shop_trade/indicatorDefinitions',
    method: 'get',
    params: data
  })
}

// 新增/更新指标定义
export function saveIndicatorDefinition(data) {
  return request({
    url: '/admin/Shop_trade/indicatorDefinitionSave',
    method: 'post',
    data
  })
}

// 删除指标定义
export function delIndicatorDefinition(data) {
  return request({
    url: '/admin/Shop_trade/indicatorDefinitionDel',
    method: 'post',
    data
  })
}

// 获取部门列表
export function getDepartmentList(data) {
  return request({
    url: '/admin/Department/getlist',
    method: 'get',
    params: data
  })
}

// 新增部门
export function departmentAdd(data) {
  return request({
    url: '/admin/Department/add',
    method: 'post',
    data
  })
}

// 更新部门
export function departmentUp(data) {
  return request({
    url: '/admin/Department/up',
    method: 'post',
    data
  })
}

// 删除部门
export function departmentDel(data) {
  return request({
    url: '/admin/Department/del',
    method: 'post',
    data
  })
}

export function tradeDel(data) {
  return request({
    url: '/admin/Shop_trade/del',
    method: 'get',
    params: data
  })
}

// 初始化指标定义种子数据
export function initIndicatorDefs() {
  return request({
    url: '/admin/Shop_trade/initIndicators',
    method: 'get'
  })
}

export function tradeUp(data) {
  return request({
    url: '/admin/Shop_trade/up',
    method: 'post',
    data
  })
}

export function tradeAdd(data) {
  return request({
    url: '/admin/Shop_trade/add',
    method: 'post',
    data
  })
}

//获取门店指店
export function getshoptradelist(data) {
  return request({
    url: '/admin/Report_list/gettradelist',
    method: 'get',
    params: data
  })
}

//个人指标列表
export function getPersonalMetricList(data) {
  return request({
    url: '/admin/User_trade/getlist',
    method: 'get',
    params: data
  })
}

//个人指标更新
export function personalMetricUp(data) {
  return request({
    url: '/admin/User_trade/up',
    method: 'post',
    data
  })
}

// 获取群聊 ID 列表
export function getRoomIdList(data) {
  return request({
    url: '/admin/Wechat_room/list',
    method: 'post',
    data
  })
}

//打卡记录
export function attendanceList(data) {
  return request({
    url: '/admin/Report_list/getattendancelist',
    method: 'get',
    params: data
  })
}

//大屏销售额
export function getturnover(data) {
  return request({
    url: '/admin/Report_bigscreen/getturnover',
    method: 'get',
    params: data
  })
}

//销售统计by日
export function getsalebyday(data) {
  return request({
    url: '/admin/Report_bigscreen/getsalebyday',
    method: 'get',
    params: data
  })
}

//销售统计by周
export function getsalebyweek(data) {
  return request({
    url: '/admin/Report_bigscreen/getsalebyweek',
    method: 'get',
    params: data
  })
}

//销售统计by年
export function getsalebyyear(data) {
  return request({
    url: '/admin/Report_bigscreen/getsalebyyear',
    method: 'get',
    params: data
  })
}

//商品热度
export function productheat(data) {
  return request({
    url: '/admin/Report_bigscreen/productheat',
    method: 'get',
    params: data
  })
}

//销售目标完成率
export function getsaletrade(data) {
  return request({
    url: '/admin/Report_bigscreen/getSaleDefMoneyTrade',
    method: 'get',
    params: data
  })
}

//大屏库存分析
export function getinventory(data) {
  return request({
    url: '/admin/Report_bigscreen/getinventory',
    method: 'get',
    params: data
  })
}

//补货
export function getbuylistbybig(data) {
  return request({
    url: '/admin/Report_bigscreen/getbuylistbybig',
    method: 'get',
    params: data
  })
}

//销售
export function getsalelistbybig(data) {
  return request({
    url: '/admin/Report_bigscreen/getsalelistbybig',
    method: 'get',
    params: data
  })
}

//采购浮动
export function getbuyrate(data) {
  return request({
    url: '/admin/Report_bigscreen/getbuyrate',
    method: 'get',
    params: data
  })
}

//打卡记录大屏
export function attendanceListbyscreen(data) {
  return request({
    url: '/admin/Report_bigscreen/getattendancelist',
    method: 'get',
    params: data
  })
}

//门店指标列表
export function gettradelistbyscreen(data) {
  return request({
    url: '/admin/Report_bigscreen/gettradelist',
    method: 'get',
    params: data
  })
}

//门店指标列表
export function getshopname(data) {
  return request({
    url: '/admin/Report_bigscreen/showshopname',
    method: 'get',
    params: data
  })
}


//首页统计
export function getAllInfobyscreen(data) {
  return request({
    url: '/admin/publicAPI/getAll_info',
    method: 'get',
    params: data
  })
}


export function closeshop(data) {
  return request({
    url: '/admin/User_Attendance/closeshop',
    method: 'get',
    params: data
  })
}

//打卡记录
export function attendanceListuser(data) {
  return request({
    url: '/admin/Report_list/getattendancelistuser',
    method: 'get',
    params: data
  })
}

// 每日资产变化
export function getAllMoneyHistory(data) {
  return request({
    url: '/admin/all_money_history/get_list',
    method: 'get',
    params: data
  })
}

//标签管理
export function getItemlabelList(data) {
  return request({
    url: '/admin/Item_label/getList',
    method: 'get',
    params: data
  })
}

export function getStockItemListByLabel(data) {
  return request({
    url: '/admin/Item_label/getStockItemListByLabel',
    method: 'get',
    params: data
  })
}

export function getCanBindStockItemList(data) {
  return request({
    url: '/admin/Item_label/getCanBindStockItemList',
    method: 'get',
    params: data
  })
}

export function batchBindStockItem(data) {
  return request({
    url: '/admin/Item_label/batchBindStockItem',
    method: 'post',
    data
  })
}

export function batchUnbindStockItem(data) {
  return request({
    url: '/admin/Item_label/batchUnbindStockItem',
    method: 'post',
    data
  })
}

export function itemLabelDel(data) {
  return request({
    url: '/admin/Item_label/del',
    method: 'get',
    params: data
  })
}

// 新增品牌接口
export function itemLabelAdd(data) {
  return request({
    url: '/admin/Item_label/add',
    method: 'post',
    data
  })
}


// 修改品牌接口
export function itemLabelUp(data) {
  return request({
    url: '/admin/Item_label/up',
    method: 'post',
    data
  })
}

// 获取标签详情
export function getItemlabelOne(data) {
  return request({
    url: '/admin/Item_label/getOne',
    method: 'get',
    params: data
  })
}

export function getbrandorigin(data) {
  return request({
    url: '/admin/Brand_origin/getlist',
    method: 'get',
    params: data
  })
}

export function brandorigindel(data) {
  return request({
    url: '/admin/Brand_origin/del',
    method: 'get',
    params: data
  })
}

// 新增品牌接口
export function brandoriginadd(data) {
  return request({
    url: '/admin/Brand_origin/add',
    method: 'post',
    data
  })
}


// 修改品牌接口
export function brandoriginup(data) {
  return request({
    url: '/admin/Brand_origin/up',
    method: 'post',
    data
  })
}

export function brandoriginone(data) {
  return request({
    url: '/admin/Brand_origin/getone',
    method: 'get',
    params: data
  })
}


// 品名训练

export function aiTrainGetList(data) {
  return request({
    url: '/admin/ai_train/getList',
    method: 'get',
    params: data
  })
}
//  删除
export function aiTrainDelete(data) {
  return request({
    url: '/admin/ai_train/delete',
    method: 'post',
    data
  })
}

// 导出
export function aiTrainExport(data) {
  return request({
    url: '/admin/ai_train/export',
    method: 'get',
    params: data
  })
}

// 导入
export function aiTrainImport(data) {
  return request({
    url: '/admin/ai_train/import',
    method: 'post',
    data
  })
}

export function aiTrainSave(data) {
  return request({
    url: '/admin/ai_train/save',
    method: 'post',
    data
  })
}

// 样式库管理 - 创建样式分类
export function createStyleClass(data) {
  return request({
    url: '/admin/Style_library/create_class',
    method: 'post',
    data
  })
}

// 样式库管理 - 获取样式分类列表
export function getStyleClassList(data) {
  return request({
    url: '/admin/Style_library/get_class_list',
    method: 'get',
    params: data
  })
}

// 样式库管理 - 根据分类id获取样式列表
export function getStyleList(data) {
  return request({
    url: '/admin/Style_library/get_style_list',
    method: 'get',
    params: data
  })
}

// 样式库管理 - 添加样式
export function addStyle(data) {
  return request({
    url: '/admin/Style_library/add_style',
    method: 'post',
    data
  })
}

// 样式库管理 - 更新样式
export function updateStyle(data) {
  return request({
    url: '/admin/Style_library/update_style',
    method: 'post',
    data
  })
}

// 轮播图管理 - 获取列表
export function getCarouselList(data) {
  return request({
    url: '/admin/Banner/getList',
    method: 'get',
    params: data
  })
}

// 轮播图管理 - 获取详情
export function getCarouselDetail(data) {
  return request({
    url: '/admin/Banner/getOne',
    method: 'get',
    params: data
  })
}

// 轮播图管理 - 新增
export function addCarousel(data) {
  return request({
    url: '/admin/Banner/add',
    method: 'post',
    data
  })
}

// 轮播图管理 - 编辑
export function updateCarousel(data) {
  return request({
    url: '/admin/Banner/up',
    method: 'post',
    data
  })
}

// 轮播图管理 - 删除
export function deleteCarousel(data) {
  return request({
    url: '/admin/Banner/del',
    method: 'post',
    data
  })
}

// 轮播图管理 - 更新状态
export function updateCarouselStatus(data) {
  return request({
    url: '/admin/Banner/up',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/basicConfiguration.js